import React, { useEffect, useState } from "react";

import { useLazyQuery } from "@apollo/client";

import { FieldFeedbackLabel } from "../../../../_metronic/_partials/controls";

import { SEARCH_COMPANY } from "./quey";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];

  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function Organization({
  field,
  form: { touched, errors },
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  ...props
}) {
  const [companyData, setCompanyData] = useState([]);

  const [
    searchCompany,
    { loading: searchLoading, data: searchCompanyData },
  ] = useLazyQuery(SEARCH_COMPANY, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (searchCompanyData) {
      setCompanyData(searchCompanyData.searchCompanyByName);
    }
  }, [searchLoading, searchCompanyData]);

  const searchCompanyByName = async ev => {
    searchCompany({
      variables: {
        name: ev.target.value,
      },
    });
  };

  return (
    <>
      {label && <label>Enter {label}</label>}
      <input
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
        placeholder="Organization Name"
        autoComplete="off"
        list="datalist"
        type="text"
        onKeyUp={e => searchCompanyByName(e)}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
      {searchLoading ? (
        <span className="ml-2 spinner"></span>
      ) : (
        <datalist id="datalist">
          {companyData.length > 0 &&
            companyData.map(o => <option value={o.name}></option>)}
        </datalist>
      )}
    </>
  );
}
